import { classAdderBuilder } from '@smui/common/classadder';
export default classAdderBuilder({
    class: 'mdc-deprecated-list-item__text',
    tag: 'span',
});
//# sourceMappingURL=Text.js.map